 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto">
        <el-input style="min-width: 150px;" placeholder="请输入关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%;">
        <tableCom :data="delegateList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_m2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
      <!-- <div class="footer grid-content bg-purple layout_box">
        <span class="text-right">
          佣金合计:
          <span class="capital">{{totalCapital}}</span>
          <span class="Currency"> (美元)</span>
          &nbsp;&nbsp;&nbsp; 提现合计:
          <span class="capital">{{totalCurrency}}</span>
          <span class="Currency"> (美元)</span>
        </span>
      </div> -->
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./mydelegationDetailT.vue";
import pagination from "../../paging.vue";

export default {
  // 筛选器
  name: "positionDetailS",
  components: {
    tableCom,
    pagination
  },
  props: ["agentID"],
  data() {
    return {
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      delegateList: [],
      totalCapital: 0,
      totalCurrency: 0,
      PositionEffectValue: "",
      PositionEffectList: [
        { Code: 0, Name: "请选择" },
        { Code: 1, Name: "开仓" },
        { Code: 2, Name: "平仓" }
      ],
      keyWord: ""
    };
  },
  mounted() {
    this.PositionEffectValue = this.PositionEffectList[0].Code;
    this.getList();
  },
  methods: {
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.$emit("mydelegation", this.keyWord);
      this.loading = true;
      let url = "/mycustomer/QryInsUserCurrentOrder";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.delegateList = response.Data.Records;
            this.totalCapital = 0;
            this.totalCurrency = 0;

            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
.pagination_m {
  bottom: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/selects/mydelegation/mydelegationDetailS.vue